/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ActionBlock":"ActionBlock_AgRNQ","container":"container_+1fL+"};